import { ImmerReducer } from 'use-immer';
import { CaptureManagerAction, CaptureManagerState } from './type';
import { addToArray } from '@vindr/utils/helpers/common.helper';

const captureManagerReducer: ImmerReducer<CaptureManagerState, CaptureManagerAction> = (
  state,
  action
) => {
  switch (action.type) {
    case 'IMPORT_FILES': {
      const file = action.payload;

      if (state.storeFiles.some((x) => x.id === file.id)) break;

      state.storeFiles.push(file);
      state.processingList.set(file.id, {
        id: file.id,
        name: file.name,
        progress: 0,
        status: 'ready',
        file: file.file,
      });

      break;
    }
    case 'IMPORT_ATTACHMENT': {
      action.payload.forEach((it) => {
        state.storeFiles.push(it);
        state.processingList.set(it.id, {
          id: it.id,
          name: it.name,
          progress: 0,
          status: 'ready',
          file: null,
        });
      });

      break;
    }
    case 'DELETE_FILES': {
      state.storeFiles = action.payload.newStoreFiles;

      action.payload.listIdSelected.forEach((id) => {
        state.processingList.delete(id);
      });
      break;
    }
    case 'SET_PROGRESS': {
      const idArray = addToArray(action.payload.id);

      idArray.forEach((id) => {
        state.processingList.set(id, {
          ...state.processingList.get(id),
          progress: action.payload.progress,
          status: action.payload.status,
        });
      });
      break;
    }
    case 'SET_SELECTED': {
      state.selected = action.payload;
      break;
    }
    case 'EDIT_FILE': {
      const indexSelected = state.storeFiles.findIndex((x) => x.id === action.payload.id);

      state.storeFiles[indexSelected] = action.payload;
      state.processingList.set(action.payload.id, {
        ...state.processingList.get(action.payload.id),
        ...action.payload,
      });
      break;
    }
    case 'SET_CONVERTING': {
      if (typeof action.payload === 'boolean') {
        state.isConverting.status = action.payload;
      } else {
        state.isConverting = action.payload;
      }
      break;
    }
    case 'SET_ERROR': {
      const idArray = addToArray(action.payload.id);

      idArray.forEach((id) => {
        const currentItem = state.processingList.get(id);

        if (currentItem && currentItem.status !== 'exception') {
          state.processingList.set(id, {
            ...currentItem,
            status: 'exception',
          });
        }
      });
      break;
    }
  }
};

export default captureManagerReducer;
